import rules from "./Common/RbacRules";
import { authContext } from '../../Utils/AdalConfig';

const check = (action, data) => {
    if (authContext.getCachedUser() != null && authContext.getCachedUser().profile != null && authContext.getCachedUser().profile.groups != null) {
        for (var fieldIndex = 0; fieldIndex < authContext.getCachedUser().profile.groups.length; fieldIndex++) {

            const permissions = rules[authContext.getCachedUser().profile.groups[fieldIndex]];


        if (permissions) {
            const staticPermissions = permissions.static;

            if (staticPermissions && staticPermissions.includes(action)) {
                // static rule not provided for action
                return true;
            }

            if (staticPermissions && staticPermissions.includes(action)) {
                // static rule not provided for action
                return true;
            }
        }

        if (permissions) {
            const dynamicPermissions = permissions.dynamic;

            if (dynamicPermissions) {
                const permissionCondition = dynamicPermissions[action];
                if (!permissionCondition) {
                    // dynamic rule not provided for action
                    return false;
                }

                return permissionCondition(data);
            }
        }
    }
    }
    //if (!permissions) {
        // role is not present in the rules
    //    return false;
    //}

    
    return false;
};

const Authorization = props =>
    check( props.perform, props.data)
        ? props.yes()
        : props.no();

Authorization.defaultProps = {
    yes: () => null,
    no: () => null
};

export default Authorization;